import { render } from "./Footer.vue?vue&type=template&id=5120bb1e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5120bb1e&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\viglacera\\nhathau\\fe\\source005\\vig_contructor_fe_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5120bb1e"]])

export default __exports__